import { tile_url, europe_extent, world_extent } from './config.js';
import WMTS from 'ol/source/WMTS';
import { get as getProjection} from 'ol/proj';
import {getTopLeft, getWidth}  from 'ol/extent';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import Tile from 'ol/layer/Tile';

const createWMTSSample = (layerName, version, max_level, view) => {	
	const getMatrixLabels = (num, prefix) => {
		let labelPrefix = prefix;
		if( prefix === undefined ) {
			labelPrefix = 'EPSG:4326:'
		}
		
		const format = (level) => labelPrefix + level; 
				
		const matrixIds = new Array(num);
		
		for (let z = 0; z < num; z++) {
			matrixIds[z] = format(z);
		}
		
		return matrixIds;
	}
	
	const inspireWgs84Grid = (levels, prefix) => {
		const projection = getProjection('EPSG:4326');

		// If tile matrix identifiers differ from zoom levels (0, 1, 2, ...)
		// then they must be explicitly provided.
		const projectionExtent = projection.getExtent();
		const resolution = getWidth(projectionExtent) / 512;
		
		const resolutions = new Array(levels);
		
		for (let z = 0; z < levels; z++) {
			resolutions[z] = resolution / Math.pow(2, z);
		}
		
		return new WMTSTileGrid({
			origin: getTopLeft(projectionExtent),
			resolutions: resolutions,
			matrixIds: getMatrixLabels(levels, prefix)
		});				
	}

	const extent = view === "world" ? world_extent : europe_extent;
	
	return new Tile({
			extent: extent,
			source : new WMTS({
				url : tile_url(version),
				layer : layerName,
				requestEncoding : 'REST',
				matrixSet : 'inspire_quad',
				format : 'image/png',
				projection : "EPGS:4326",
				tileGrid : inspireWgs84Grid(max_level || 12, '')
			})
		});
}

export default createWMTSSample;